import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EAppStatusActions {
  SetLoading = 'APP_STATUS/SET_LOADING',
  SetError = 'APP_STATUS/SET_ERROR',
}

export type TSetLoading = ITypedReduxAction<EAppStatusActions.SetLoading, boolean>;
export type TSetError = ITypedReduxAction<EAppStatusActions.SetError, string | undefined>;

export const setLoading = actionGenerator<EAppStatusActions.SetLoading, boolean>(EAppStatusActions.SetLoading);
export const setError = actionGenerator<EAppStatusActions.SetError, string | undefined>(EAppStatusActions.SetError);

export type TAppStatusActions = TSetLoading | TSetError;
